import Splide from '@splidejs/splide';



document.querySelectorAll('[data-email]').forEach((element) => {
	const encodedEmail = element.textContent;
	const decodedEmail = atob(encodedEmail);
	element.textContent = decodedEmail;
	element.href = 'mailto:' + decodedEmail;
});


const footer = document.querySelector('#footer');
const main = document.querySelector('#main');
const header = document.querySelector('header');
const headerHeight = header.offsetHeight;


if (window.matchMedia('(max-width: 959px)').matches) {
	const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
	const mobileMenu = document.querySelector('#mobile-dropdown');

	mobileMenuToggle.addEventListener('click', () => {
		mobileMenuToggle.classList.toggle('active');
		mobileMenu.classList.toggle('active');
	});

	// Fermer le menu quand on clique sur un lien (sauf les liens principaux des éléments parents)
	const closeMobileMenu = (e) => {
		// Vérifier si c'est un lien principal d'un élément parent
		const isParentLink = e.target.closest('.menu-item-has-children') && !e.target.closest('.sub-menu');

		if (!isParentLink) {
			// C'est un lien normal ou un lien de sous-menu, fermer le menu
			mobileMenuToggle.classList.remove('active');
			mobileMenu.classList.remove('active');
		}
	};

	// Ajouter l'écouteur sur tous les liens du menu mobile
	const mobileMenuLinks = mobileMenu.querySelectorAll('a');
	mobileMenuLinks.forEach(link => {
		link.addEventListener('click', closeMobileMenu);
	});

	if (
		document.querySelectorAll('#mobile-dropdown .menu-item-has-children')
			.length > 0
	) {
		const hasChildren = document.querySelectorAll(
			'#mobile-dropdown .menu-item-has-children'
		);

		if (hasChildren.length > 0) {
			hasChildren.forEach((element) => {
				element.addEventListener('click', (e) => {
					// Vérifier si l'élément cliqué est un lien
					const link = e.target.closest('a');

					if (link && link.href) {
						// Vérifier si le lien est dans un sous-menu
						const isInSubMenu = link.closest('.sub-menu');

						if (isInSubMenu) {
							// C'est un lien de sous-menu, permettre la navigation et fermer le menu
							// closeMobileMenu va être appelé automatiquement par l'écouteur sur le lien
							return true;
						} else {
							// C'est le lien principal du menu, toggler ou fermer le sous-menu
							e.preventDefault();
							const subMenu = element.querySelector('.sub-menu');

							if (element.classList.contains('active')) {
								// Le sous-menu est ouvert, le fermer
								element.classList.remove('active');
								if (subMenu) {
									subMenu.classList.remove('active');
								}
							} else {
								// Le sous-menu est fermé, l'ouvrir
								element.classList.add('active');
								if (subMenu) {
									subMenu.classList.add('active');
								}
							}
						}
					}
				});
			});
		}
	}
}



// si le media est plus grand que 1024px
if (window.matchMedia('(min-width: 1024px)').matches) {
	const footerHeight = footer.offsetHeight - 1;
	footer.style.position = 'fixed';
	main.style.marginBottom = footerHeight + 'px';
}

if (document.querySelector('.splide')) {
	new Splide('.splide',{
		type: 'loop',
		arrows: false,
		autoplay: false,
		interval: 5000,
	}).mount();
}

if (document.querySelector('.anchor')) {
	const anchors = document.querySelectorAll('.anchor');
	anchors.forEach(anchor => {
		const decallage = headerHeight + 50;
		anchor.style.paddingTop = decallage + 'px';
		anchor.style.marginTop = - decallage + 'px';
	});
}
